<template>
  <div class="tad-wrap">
    <button
      ref="triggerRef"
      class="tad-trigger"
      :class="{ open: isOpen }"
      type="button"
      :aria-label="ariaLabel"
      @click.stop="toggle"
    >
      <i class="fas fa-ellipsis-v"></i>
    </button>

    <!-- KEY: Teleport renders the menu on <body>, completely outside the table -->
    <Teleport to="body">
      <div
        v-if="isOpen"
        ref="menuRef"
        class="tad-menu"
        :style="menuStyle"
        @click.stop
      >
        <slot />
      </div>
    </Teleport>
  </div>
</template>

<script>
export default {
  name: 'TableActionDropdown',
  props: {
    ariaLabel: { type: String, default: 'Row actions' }
  },
  data() {
    return {
      isOpen: false,
      menuStyle: {}
    }
  },
  mounted() {
    document.addEventListener('click', this.onOutsideClick)
    document.addEventListener('scroll', this.close, true)
    window.addEventListener('resize', this.close)
  },
  beforeUnmount() {
    document.removeEventListener('click', this.onOutsideClick)
    document.removeEventListener('scroll', this.close, true)
    window.removeEventListener('resize', this.close)
  },
  methods: {
    toggle() {
      this.isOpen ? this.close() : this.open()
    },
    open() {
      this.isOpen = true
      this.$nextTick(this.position)
    },
    close() {
      this.isOpen = false
    },
   position() {
  const btn = this.$refs.triggerRef
  const menu = this.$refs.menuRef
  if (!btn || !menu) return

  const r = btn.getBoundingClientRect()
  const menuH = menu.offsetHeight || 120
  const collapsedW = 46   // collapsed width
  const expandedW = 130   // hover width

  const spaceBelow = window.innerHeight - r.bottom

  const top = spaceBelow < menuH + 8
    ? r.top - menuH - 4
    : r.bottom + 4
  const right = window.innerWidth - r.right

  this.menuStyle = {
    position: 'fixed',
    top: `${top}px`,
    right: `${right}px`,   // use right instead of left
    left: 'auto',
    zIndex: 9999
  }
},
    onOutsideClick(e) {
      if (
        !this.$refs.triggerRef?.contains(e.target) &&
        !this.$refs.menuRef?.contains(e.target)
      ) {
        this.close()
      }
    }
  }
}
</script>

<style scoped>
.tad-wrap {
  display: flex;
  justify-content: center;
}

.tad-trigger {
  width: 30px;
  height: 30px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border: 1px solid rgba(0,0,0,0.07);
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}
.tad-trigger:hover {
  background: #f8fafc;
  border-color: rgba(0,0,0,0.14);
  color: #374151;
}
.tad-trigger.open {
  outline: none;
  box-shadow: 0 0 0 3px rgba(83,74,183,0.12);
  background: #f8fafc;
  border-color: #534AB7;
}
</style>